import { FormGroup, FormLabel } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import NumberInput from '../common/NumberInput';
import { hide } from './weaveInfoSlice';
import { getTrainerResults, setWeaveStartPercent, setWeaveTargetPercent } from './weaveTrainerSlice';

function InnerWeaveInfoModal() {
  const dispatch = useAppDispatch();
  const weave = useAppSelector(state => state.weaveTrainer.weaves.find(x => x.id === state.weaveInfo.weaveId)!);

  const { name, percentStart, percentTarget, pracsActual, percentActual, percentHistory, busy } = weave;
  const percents = percentHistory.join(', ');

  const handleStartPercentChange = (value: number) => {
    dispatch(setWeaveStartPercent({weaveId: weave.id, percent: value}));
    dispatch(getTrainerResults());
  }

  const handleTargetPercentageChange = (value: number) => {
    dispatch(setWeaveTargetPercent({weaveId: weave.id, percent: value}));
    dispatch(getTrainerResults());
  }

  const handleClose = () => {
    dispatch(hide());
  }
  
  return (
    <Modal show={true} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
        <div className="row">
          <FormGroup className="mb-3 col">
            <FormLabel>Start Percent</FormLabel>
            <NumberInput
              min={0} max={99} numberValue={percentStart || null}
              onNumberChange={e => handleStartPercentChange(e ?? 0)} />
          </FormGroup>
          <FormGroup className="mb-3 col">
            <FormLabel>Target Percent</FormLabel>
            <NumberInput
              min={0} max={99} numberValue={percentTarget || null}
              onNumberChange={e => handleTargetPercentageChange(e ?? 0)} />
          </FormGroup>
        </div>

        <div className="mb-3">
          <FormLabel>Results:</FormLabel>
          <div className="mx-3" style={{minHeight: "5.5rem"}}>
            {busy ?
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            : null}

            {!busy && !percentActual ?
              <div>None</div>
            : null}

            {!busy && percentActual ?
              <>
                <div className="d-flex mb-3">
                  <div className="me-3">{percentActual}%,</div>
                  <div>{pracsActual} practices</div>
                </div>
                <div>{percents ? percents + '%' : null}</div>
              </>
            : null}
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => handleClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function WeaveInfoModal() {
  const visible = useAppSelector(state => state.weaveInfo.visible);  
  return visible ? <InnerWeaveInfoModal/> : null;
}

export default WeaveInfoModal;